<template>
    <v-modal
        name="content-page-modal"
        :adaptive="true"
        :max-width="800"
        width="80%"
        height="auto"
        :scrollable="true"
        @closed="closeModal"
    >
        <layout-modal @close="closeModal">
            <div v-if="isLoading" class="loading">
                <spinner />
            </div>

            <!-- eslint-disable -->
            <!-- Necessary for v-html because it allows XXS attacks -->
            <div v-else class="content" v-html="text" />
            <!-- eslint-enable -->
        </layout-modal>
    </v-modal>
</template>

<script>
import { mapActions } from "vuex";
import LayoutModal from "../layouts/LayoutModal";

import { ContentNotFoundError } from "@/store/modules/content";

export default {
    components: {
        LayoutModal
    },
    props: {
        autoOpen: {
            type: Boolean,
            required: false,
            default: false
        },
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            text: null
        };
    },
    computed: {
        isLoading() {
            return this.text === null;
        },
        page() {
            return `${this.name}.${this.$i18n.locale}`
        }
    },
    watch: {
        page: {
            handler: "updateContentPage",
            immediate: true
        }
    },
    methods: {
        closeModal() {
            this.$modal.hide("content-page-modal");
            this.$emit("close");
        },
        updateContentPage: function() {
            this.text = null;
            return this.getContentPage({
                identifier: this.name,
                languageCode: this.$i18n.locale
            })
                .then(contentPage => {
                    if (contentPage) {
                        this.text = contentPage.body;

                        // If auto open is true and the content is present. We open the modal
                        if (this.autoOpen && contentPage.body !== "") {
                            this.$modal.show("content-page-modal");
                        }
                    }
                })
                .catch(e => {
                    if (e instanceof ContentNotFoundError) {
                        this.$sendError(e);
                    } else {
                        // https://github.com/vuejs/vue/pull/9484
                        // async watcher errors are not captured, so we ignore other errors for now
                        // TODO: checkup on PR and see when resolved.
                    }
                })
                .finally(() => {
                    if (this.text === null) {
                        this.text =
                            this.$t("modal_content_page.title") +
                            "<br />" +
                            this.$t("modal_content_page.description");
                    }
                });
        },
        ...mapActions({
            getContentPage: "content/getContentPage"
        })
    }
};
</script>

<style scoped>
/* Need to bypass scoped style for this to work when inject raw html */
.content >>> h1 {
    font-size: 1.2em;
}
</style>
